export default {
  match: (state) => (matchId) => state.matchs.find((match) => { return match.id === matchId }),
  matchActionsStatistics: (state) => (matchId, name) => {
    const statistics = state.matchsActionsStatistics.find((statistic) => { return statistic.id === matchId })
    return statistics ? statistics[name] : 0
  },

  actions: (state) => (matchId) => {
    return state.actions.filter(
      (action) => action.matchId === matchId
    )
  },
  actionsSorted: (state) => (matchId) => {
    return state.actions.filter(
      (action) => action.matchId === matchId
    ).sort(
      (a, b) => {
        if (b.date && a.date) {
          return new Date(b.date).getTime() - new Date(a.date).getTime()
        } else if (a.statusId === b.statusId) {
          return b.minute - a.minute
        } else {
          return b.statusId - a.statusId
        }
      }
    )
  },
  action: (state) => (actionId) => { return state.actions.find((action) => { return action.id === actionId }) },

  status: (state) => state.status,
  statistics: (state) => state.statistics.list
}
